import styled from 'styled-components';
import { ReactComponent as Phone } from '../media/phone-call-icon.svg';
import { ReactComponent as Mail } from '../media/mail-icon.svg';
import { QuoteRequestButton } from './QuoteRequestButton';
import { Card } from './Card';
import { useTranslation } from "react-i18next";
import { namespaces } from "../i18n.costants";
import { AnchorHTMLAttributes } from 'react';
import {GeneralText} from "./GeneralText";

type ContactCardProps = {
  handleClick?: () => void;
};
export function ContactCard({ handleClick }: ContactCardProps) {
  const { t } = useTranslation(namespaces.common);

  return (
    <Card title={t("Contattaci")} id={t("nav/contact")}>
      <FormContainer>
        <Form>
          <ContactIconContainer>
            <Phone fill="var(--color-blue)" />
          </ContactIconContainer>
         <Contact>Tel: <Link href="tel:+393898836147">+39&nbsp;389&nbsp;8836147</Link></Contact>
        </Form>
        <Form>
          <ContactIconContainer>
            <Mail fill="var(--color-blue)" />
          </ContactIconContainer>
          <Contact>{t("Avete domande?")}</Contact>
          <Contact>{t("Non esitate a contattarci")}</Contact>
          <Contact><Link href="mailto:vevservizisrl@gmail.com">vevservizisrl@gmail.com</Link></Contact>
        </Form>
      </FormContainer>

      <MapWrapper>
        <Iframe
          title="map"
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyB2NIWI3Tv9iDPrlnowr_0ZqZWoAQydKJU&q=VEV%20Servizi%20SNC%2C%20Via%20Contarina%2C%20Verona%2C%20VR%2C%20Italy&maptype=roadmap"
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
        />
      </MapWrapper>

      <GeneralText style={{ marginBlock: "2rem" }}>
        {t("__Contattare_attraverso_il_form__")}
      </GeneralText>
      <QuoteRequestButton handleClick={handleClick} text={t("Richiedi maggiori informazioni")} style={{ marginBottom: "2rem" }}/>
    </Card>
  )
}

const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--gap);

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;
const Form = styled.form`
  margin: 20px 0;
  background: white;
  grid-column: span 4;
  padding: 100px 20px 20px;
  position: relative;
  flex: 1 1;
  border-radius: var(--radius);
`;
const ContactIconContainer = styled.div`
  width: var(--contact-icon-size);
  height: var(--contact-icon-size);
  position: absolute;
  top: -20px;
  left: calc(50% - 45px);
  margin: auto;
  padding: 20px;
  border-radius: 50%;
  background-color: var(--color-gray-light);
  display: flex;
  justify-content: center;
  box-shadow: 3px 5px 15px rgba(0,0,0,0.2);
`;
const Contact = styled.div`
  text-align: center;
  font-size: 1em;
  word-wrap: anywhere;
`;
const Link = styled.a<AnchorHTMLAttributes<HTMLAnchorElement>>`
  color: var(--color-blue);
`;
const MapWrapper = styled.div`
  width: 100%;
  height: 400px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
`;
const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`;